<template>
  <router-view />
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  watch: {},
  computed: mapState([]),
  components: {},
  mounted() {}
};
</script>
